import MainFiltersBQ from "../../../../Global/Models/Filters/MainFiltersBQ";

export default class BracketGameRankingsFilters extends MainFiltersBQ {}
